module.exports = __webpack_public_path__ + "static/officers-57bf7c3a7b2ae4479a4897a732c8569e.jpg";